<template>
  <b-container fluid>
    <div>
      <h2 class="mt-4">Tournament</h2>
      <b-tabs>
        <b-tab title="Schedule" class="mx-3" title-link-class="text-info">
          <Schedule :matches="matches"/>
        </b-tab>
        <b-tab title="Current Match" title-link-class="text-info">
          <MatchDetail/>
        </b-tab>
        <b-tab title="Lightweight 70,3 kg" title-link-class="text-danger">
          <Brackets/>
        </b-tab>
        <b-tab title="Welterweight 77,1 kg" title-link-class="text-primary">
          <Brackets/>
        </b-tab>
        <b-tab title="Middleweight 83,9 kg" title-link-class="text-primary">
          <Brackets/>
        </b-tab>
        <b-tab title="Light-Heavyweight 93,0 kg" title-link-class="text-primary">
          <Brackets/>
        </b-tab>
        <b-tab title="Heavyweight 120,2 kg" title-link-class="text-primary">
          <Brackets/>
        </b-tab>
      </b-tabs>
    </div>
    <MatchDetail v-if="!showTournament"/>
  </b-container>
</template>

<script>
import Brackets from '../components/Brackets.vue';
import MatchDetail from '../components/MatchDetail.vue';
import Schedule from '../components/Schedule.vue';

export default {
  name: 'Tournament',
  components: {
    Schedule,
    MatchDetail,
    Brackets,
  },
  data() {
    return {
      fields: [
        '#', 'time', 'weightClass',
        {
          key: 'redCorner',
          variant: 'danger',
        },
        {
          key: 'blueCorner',
          variant: 'primary',
        },
        'action',
      ],
      items: [
        {
          '#': '1',
          time: '12:00',
          weightClass: 'Lightweight',
          redCorner: 'Alpha - Alpha Team',
          blueCorner: 'Beta - Bravo Team',
        },
        {
          '#': '2',
          time: '12:15',
          weightClass: 'Lightweight',
          redCorner: 'Charlie - C Team',
          blueCorner: 'Dora - D Team',
        },
        {
          '#': '3',
          time: '12:30',
          weightClass: 'Lightweight',
          redCorner: 'Emil  - E Team',
          blueCorner: 'Franz - F Team',
        },
        {
          '#': '4',
          time: '12:45',
          weightClass: 'Welterweight',
          redCorner: 'Gustav - G Team',
          blueCorner: 'Hubert - H Team',
        },
      ],
      matches: [
        {
          id: '1',
          type: 'Matchfight',
          weightClass: 'Lightweight',
          redCorner: 'Franz Schwerdtmann',
          blueCorner: 'Clemens Werner',
        },
        {
          id: '2',
          type: 'Tournament',
          weightClass: 'Lightweight',
          redCorner: 'A',
          blueCorner: 'J',
        },
        {
          id: '3',
          type: 'Tournament',
          weightClass: 'Lightweight',
          redCorner: 'B',
          blueCorner: 'I',
        },
        {
          id: '4',
          type: 'Matchfight',
          weightClass: 'Welterweight',
          redCorner: 'C',
          blueCorner: 'H',
        },
        {
          id: '5',
          type: 'Tournament',
          weightClass: 'Welterweight',
          redCorner: 'D',
          blueCorner: 'G',
        },
        {
          id: '6',
          type: 'Tournament',
          weightClass: 'Middleweight',
          redCorner: 'E',
          blueCorner: 'F',
        },
      ],
    };
  },
  methods: {
    openMatchDetail() {
      this.$store.commit('setTournament', false);
    },
  },
  computed: {
    showTournament() {
      return this.$store.state.showTournament;
    },
  },
};
</script>

<style scoped></style>
